export enum ColorsVariablesNames {
  svPrimary = 'sv-primary',
  svPrimary900 = 'sv-primary-900',
  svPrimary200 = 'sv-primary-200',
  svSecondary = 'sv-secondary',
  svGray = 'sv-gray',
  svSuccess = 'sv-success',
  svDanger = 'sv-danger',
  svBlack = 'sv-black',
  svWhite = 'sv-white',
  svGray100 = 'sv-gray-100',
  svGray200 = 'sv-gray-200',
  svGray300 = 'sv-gray-300',
  svGray400 = 'sv-gray-400',
  svGray500 = 'sv-gray-500',
  svGray600 = 'sv-gray-600',
  svGray700 = 'sv-gray-700',
  svGray800 = 'sv-gray-800',
}

export interface ColorsVariables {
  [ColorsVariablesNames.svPrimary]?: string;
  [ColorsVariablesNames.svPrimary900]?: string;
  [ColorsVariablesNames.svPrimary200]?: string;
  [ColorsVariablesNames.svSecondary]?: string;
  [ColorsVariablesNames.svGray]?: string;
  [ColorsVariablesNames.svSuccess]?: string;
  [ColorsVariablesNames.svDanger]?: string;
  [ColorsVariablesNames.svBlack]?: string;
  [ColorsVariablesNames.svWhite]?: string;
  [ColorsVariablesNames.svGray100]?: string;
  [ColorsVariablesNames.svGray200]?: string;
  [ColorsVariablesNames.svGray300]?: string;
  [ColorsVariablesNames.svGray400]?: string;
  [ColorsVariablesNames.svGray500]?: string;
  [ColorsVariablesNames.svGray600]?: string;
  [ColorsVariablesNames.svGray700]?: string;
  [ColorsVariablesNames.svGray800]?: string;
}
